import { Image, Text, View } from '@react-pdf/renderer'
const Logo = 'https://sigah.blob.core.windows.net/assets/front/LogoColorida.png'
const LogoBranca = 'https://sigah.blob.core.windows.net/assets/front/Logo.png'

interface iProps {
  nomeVaga: string
  nomeAvaliado: string
  numerada?: boolean
  sumario?: boolean
}

export const Footer: React.FC<iProps> = ({ nomeAvaliado, nomeVaga, numerada, sumario }) => {
  function ReturnNome(): string {
    const nomes = nomeAvaliado.split(' ')

    return `${nomes[0]} ${nomes.length > 1 ? nomes[nomes.length - 1] : ''}`
  }

  return (
        <div
            style={{
              height: sumario ? '19px' : '24px',
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'space-between',
              flexDirection: 'row',
              flexWrap: 'nowrap',
              padding: '0 14px'
            }}
        >
            <View>
                <Image
                    style={{
                      height: 29,
                      objectFit: 'contain'
                    }}
                    source={sumario ? LogoBranca : Logo}
                />
            </View>
            <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', justifyContent: 'center', alignItems: 'center', height: '100%', gap: '8px' }}>
                <Text style={{ fontSize: '11px', color: sumario ? 'white' : 'black' }}>Assessment {nomeVaga} - {ReturnNome()}</Text>
                {numerada && <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', width: '19px', height: '19px', fontSize: '11px', borderRadius: '50%', backgroundColor: 'black', color: 'white' }}>
                  <Text render={({ pageNumber }) => `${pageNumber}`}/>
                </View>}
            </View>
        </div>
  )
}
